import { Component, Input, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: ['./avatar.component.css']
})
export class AvatarComponent implements OnInit, OnDestroy {
  @Input() width: number;
  @Input() height: number;
  resource: string | SafeResourceUrl = "/assets/img/default-pic.webp";

  private url: string;
  // defaultResource: string = '/assets/img/default-pic.webp';
  constructor(
    public dataService: DataService,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    if (this.dataService.userImage) {
      this.url = URL.createObjectURL(this.dataService.userImage);
      this.resource = this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
    } else {
      this.resource =  "/assets/img/default-pic.webp";
    }
    this.dataService.onImageLoad.subscribe(response => {
      URL.revokeObjectURL(this.url);
      this.url = URL.createObjectURL(response);
      this.resource = this.sanitizer.bypassSecurityTrustResourceUrl(this.url)
    });
    // this.dataService.getImage()
    // .then(response => {
    //   this.resource = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.dataService.userImage || this.dataService.defaultImage));
    //   console.log(response)
    // })
    // .catch(console.error)
  }
  ngOnDestroy(): void {
    URL.revokeObjectURL(this.url)
  }
  // get resource(): SafeResourceUrl {
  //   if (this.userAvatarFile)
  //     return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(this.dataService.userImage));
  //   return this.defaultResource;
  // }
}
